import { useState } from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { apiSetSubmitStage } from "utils/API/TrxNowAPI";
import { Header, PaginationHelper, TitleBar } from "webapp/components";
import { DAAMemberSearchForm } from "webapp/components/Partner/DAA/DAAMemberSearchForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

function DAAMemberSearch(props) {
  const { t } = useTranslation();
  const formRef = useRef();

  const [firstName, setFirstName] = useState(props.currState.MemberLookup.firstName || props.currState.FirstName || "");

  const [lastName, setLastName] = useState(props.currState.MemberLookup.lastName || props.currState.LastName || "");

  const [phone, setPhone] = useState(props.currState.MemberLookup.phone || props.currState.Number || "");

  const [memberNumber, setMemberNumber] = useState(props.currState.MemberLookup.memberNumber || "");

  const [postalCode, setPostalCode] = useState(props.currState.MemberLookup.postalCode || "");

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType || "");

  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onUserNext = () => {
    devLog("formRef", formRef);
    if (typeof formRef.onUserNext === "function") {
      formRef.current.submit();
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onFormLoad = (ref) => {
    devLog("onFormLoad", formRef, ref);
    formRef.current = ref;
    devLog("onFormLoad", formRef);
  };

  const onFormUpdate = (data) => {
    devLog("onFormUpdate", data);
    if (typeof data === "object") {
      if (typeof data.firstName === "string") {
        setFirstName(data.firstName);
      }
      if (typeof data.lastName === "string") {
        setLastName(data.lastName);
      }
      if (typeof data.phone === "string") {
        setPhone(data.phone);
      }
      if (typeof data.memberNumber === "string") {
        setMemberNumber(data.memberNumber);
      }
      if (typeof data.postalCode === "string") {
        setPostalCode(data.postalCode);
      }
      if (typeof data.searchType === "string") {
        setSearchType(data.searchType);
      }
    }
  };

  const onFormSubmit = (data) => {
    const context = props.context;
    const naviState = context.state.navigationService.getState(AppState.MemberSearch);
    devLog("ContractSearch", naviState);
    onFormUpdate(data);
    const nextState =
      naviState && typeof naviState.nextState === "number" ? naviState.nextState : AppState.ConfirmVehicle;
    context.setState(
      {
        FirstName: props.context.state.FirstName,
        LastName: props.context.state.LastName,
        webAppState: nextState,
        MemberLookup: {
          firstName: data.firstName,
          lastName: data.lastName,
          phone: data.phone,
          memberNumber: data.memberNumber,
          postalCode: data.postalCode,
          searchType: data.searchType,
        },
      },
      () => {
        apiSetSubmitStage(
          context.state,
          nextState,
          context.state.DisablementAddress || "DisablementAddress Not Available",
        );
        context.saveWebAppState(context);
      },
    );
  };

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("FIMC.ContractSearch.TitleBar2")}</strong>
          <br />
        </p>
      </>
    ),
  };

  return (
    <div>
      <Header currState={props.currState} onUserBack={onUserBack} information={t("BWC.ContractSearch.TitleBar1")} />
      <TitleBar data={LocateUserObj} />
      <PaginationHelper context={props.context} />
      <DAAMemberSearchForm
        firstName={firstName}
        lastName={lastName}
        phone={phone}
        postalCode={postalCode}
        memberNumber={memberNumber}
        searchType={searchType}
        onFormUpdate={onFormUpdate}
        onFormLoad={onFormLoad}
        onFormSubmit={onFormSubmit}
        onUserCancel={onUserCancel}
        onNextClick={onUserNext}
        currState={props.currState}
        context={props.context}
      />
    </div>
  );
}

export default DAAMemberSearch;
